/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2016
 *
 * Created by maximeallex on 2016-11-30.
 */


'use strict';
import { NgModule } from '@angular/core';
import { TooltipDirective } from './directive';
import { TooltipService } from './service';
import { TooltipComponent } from './component';
import { BrowserModule } from '@angular/platform-browser';
import {LKIcon} from "../icon/module";

@NgModule({
  imports     : [
    BrowserModule,
    LKIcon
  ],
  declarations: [TooltipDirective, TooltipComponent],
  exports     : [TooltipDirective, TooltipComponent],
  providers   : [
    TooltipService
  ]
})
export class LKTooltip {
}
